import CompanyForm from './CompanyForm'
import CompanyUserForm from './CompanyUserForm'
import ConstructionObjectCompanyForm from './ConstructionObjectCompanyForm'
import ConstructionObjectUserForm from './ConstructionObjectUserForm'
import ExternalDeviceForm from './ExternalDeviceForm'
import ImageUploader from './ImageUploader'
import TaskActivitiesLoader from './TaskActivitiesLoader'
import UserForm from './UserForm'

export default container => {
  ;[
    CompanyUserForm,
    CompanyForm,
    ConstructionObjectCompanyForm,
    ConstructionObjectUserForm,
    UserForm,
    ImageUploader,
    ExternalDeviceForm,
    TaskActivitiesLoader
  ].forEach(Handler => {
    container.querySelectorAll(Handler.selector).forEach(element => new Handler(element))
  })
}
